import { APIResponseSubmissionExerciseAssessment } from "service/APITypes";

export type FeedbackMessage = {
  category: string;
  valuation: ValuationType;
  content: string;
  position: AbsoluteFeedbackPosition | string | undefined;
};

export type AbsoluteFeedbackPosition = {
  x: number;
  y: number;
};

export enum ValuationType {
  OTHER = 0,
  POSITIVE = 1,
  NEGATIVE = 2,
  NEUTRAL = 3,
}

const message1: FeedbackMessage = {
  category: "Sample1",
  valuation: ValuationType.POSITIVE,
  content: "This was right!",
  position: "c3970e95-8bf9-4476-9879-38d4a09109b3",
};

const message11: FeedbackMessage = {
  category: "Sample1",
  valuation: ValuationType.NEGATIVE,
  content: "This was wrong!",
  position: "c3970e95-8bf9-4476-9879-38d4a09109b3",
};

const message2: FeedbackMessage = {
  category: "Sample1",
  valuation: ValuationType.NEGATIVE,
  content: "This was wrong!",
  position: "32169f12-ade2-41a8-ba43-6d8dbb77065a",
};

const message3: FeedbackMessage = {
  category: "Sample1",
  valuation: ValuationType.NEUTRAL,
  content: "This was ok!",
  position: "d7420e2c-2768-4f0c-a10a-7bfcee688396",
};

const message4: FeedbackMessage = {
  category: "Sample1",
  valuation: ValuationType.POSITIVE,
  content: "This was i dont know!",
  position: "ddc57991-365c-46c6-882d-e27884b30817",
};

const message5: FeedbackMessage = {
  category: "Sample2",
  valuation: ValuationType.POSITIVE,
  content: "This was i a link feedback!",
  position: "d71bd2de-92ec-4368-b776-083515311e96",
};

export const sampleFeedbackMessages: Array<FeedbackMessage> = [
  message1,
  message2,
  message3,
  message4,
  message5,
  message11,
];

export const feedbackSamplegraph = {
  cells: [
    {
      type: "kea.Link",
      linkType: "solid",
      targetMarker: "none",
      sourceMarker: "none",
      keaLabels: [],
      source: {
        id: "32169f12-ade2-41a8-ba43-6d8dbb77065a",
        selector: "boundary",
      },
      target: {
        id: "c3970e95-8bf9-4476-9879-38d4a09109b3",
        selector: "boundary",
      },
      id: "d71bd2de-92ec-4368-b776-083515311e96",
      z: 9,
      attrs: {
        line: {
          sourceMarker: {
            stroke: "black",
          },
          targetMarker: {
            stroke: "black",
          },
        },
      },
    },
    {
      type: "kea.EPKFunction",
      size: {
        width: 200,
        height: 100,
      },
      label: "function",
      position: {
        x: 630,
        y: 105,
      },
      angle: 0,
      id: "32169f12-ade2-41a8-ba43-6d8dbb77065a",
      z: 2,
      attrs: {
        label: {
          text: "function",
        },
      },
    },
    {
      type: "kea.EPKEvent",
      size: {
        width: 200,
        height: 100,
      },
      fillColor: "#FFFFFF",
      strokeColor: "#333333",
      strokeWidth: 2,
      label: "event",
      labelColor: "#333333",
      position: {
        x: 525,
        y: 430,
      },
      angle: 0,
      id: "c3970e95-8bf9-4476-9879-38d4a09109b3",
      z: 3,
      attrs: {
        label: {
          text: "event",
        },
      },
    },
    {
      type: "kea.EPKConnector",
      size: {
        width: 50,
        height: 50,
      },
      connectorType: "OR",
      position: {
        x: 1005,
        y: 140,
      },
      angle: 0,
      id: "d7420e2c-2768-4f0c-a10a-7bfcee688396",
      z: 5,
      attrs: {
        label: {
          text: "v",
        },
      },
    },
    {
      type: "kea.EPKConnector",
      size: {
        width: 50,
        height: 50,
      },
      connectorType: "AND",
      position: {
        x: 955,
        y: 410,
      },
      angle: 0,
      id: "ddc57991-365c-46c6-882d-e27884b30817",
      z: 6,
      attrs: {},
    },
  ],
  timesCopied: 0,
  dragStartPosition: {},
};

export const actualAPIResponse: APIResponseSubmissionExerciseAssessment = {
  success: true,
  statusCode: 200,
  statusMsg: "OK",
  timestamp: "2021-12-16T12:21:05.236Z",
  data: {
    id: 4,
    totalscore: 0.456225,
    maxTotalScore: "10.00",
    comment: null,
    autoAssessment: false,
    finalResult: false,
    status: "complete",
    submissionExerciseId: 2,
    schemaId: 4,
    createdAt: "2021-12-16T11:35:44.000Z",
    updatedAt: "2021-12-16T11:35:46.000Z",
    feedbacksmanual: [],
    gradings: [
      {
        id: 9,
        result: "0.58",
        resultType: "RELATIVE",
        logMessage:
          'Got DTO from KEAMOD backend: assessmentInfo {\n  assessmentId: 4\n  schematreeId: 5\n  gradingserviceId: 1\n  weight: 50\n  maxTotalscore: 10.0\n}\nsubmissionModel: "{\\"type\\":\\"EPC\\",\\"graph\\":{\\"cells\\":[{\\"z\\":5,\\"id\\":\\"f597aff9-ec00-4436-a368-cef003d50c7e\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"c56dcd83-bb4a-41fc-bedc-760155b6ea62\\"},\\"target\\":{\\"id\\":\\"6f54b0ae-c522-4d29-80d8-d0aaea396fac\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":5,\\"id\\":\\"a4f8c82b-55c6-4998-b7c8-9ba7d6c59200\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"6f54b0ae-c522-4d29-80d8-d0aaea396fac\\"},\\"target\\":{\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":5,\\"id\\":\\"041a3eee-2cbd-4995-8f06-53313672d220\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\"},\\"target\\":{\\"id\\":\\"293f7f94-058a-4b1f-94c7-f20bac010f79\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":5,\\"id\\":\\"6b875066-b328-45bf-97be-89ee10c03116\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\"},\\"target\\":{\\"id\\":\\"62ba1cb1-7d1a-429e-95be-2a345d9878b5\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":10,\\"id\\":\\"293f7f94-058a-4b1f-94c7-f20bac010f79\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKEvent\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"A\\"}},\\"label\\":\\"A\\",\\"position\\":{\\"x\\":470,\\"y\\":460},\\"fillColor\\":\\"#FFFFFF\\",\\"labelColor\\":\\"#333333\\",\\"strokeColor\\":\\"#333333\\",\\"strokeWidth\\":2},{\\"z\\":11,\\"id\\":\\"62ba1cb1-7d1a-429e-95be-2a345d9878b5\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKEvent\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"B\\"}},\\"label\\":\\"B\\",\\"position\\":{\\"x\\":1020,\\"y\\":430},\\"fillColor\\":\\"#FFFFFF\\",\\"labelColor\\":\\"#333333\\",\\"strokeColor\\":\\"#333333\\",\\"strokeWidth\\":2},{\\"z\\":13,\\"id\\":\\"c56dcd83-bb4a-41fc-bedc-760155b6ea62\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKEvent\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"Start-Ereignis\\"}},\\"label\\":\\"Start-Ereignis\\",\\"position\\":{\\"x\\":720,\\"y\\":80},\\"fillColor\\":\\"#FFFFFF\\",\\"labelColor\\":\\"#333333\\",\\"strokeColor\\":\\"#333333\\",\\"strokeWidth\\":2},{\\"z\\":14,\\"id\\":\\"6f54b0ae-c522-4d29-80d8-d0aaea396fac\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKFunction\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"Function 1\\"}},\\"label\\":\\"Function 1\\",\\"position\\":{\\"x\\":720,\\"y\\":240}},{\\"z\\":15,\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\",\\"size\\":{\\"width\\":50,\\"height\\":50},\\"type\\":\\"kea.EPKConnector\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"XOR\\",\\"fontSize\\":14}},\\"position\\":{\\"x\\":800,\\"y\\":370},\\"connectorType\\":\\"XOR\\"}],\\"timesCopied\\":0,\\"dragStartPosition\\":{}}}"\nmodelingLanguage: "EPC"\n\r\nStart grading...\r\nGrading was successful...',
        jobSuccessful: true,
        executionTimeMillis: 1337,
        assessmentId: 4,
        gradingserviceId: 1,
        schematreeId: 5,
        createdAt: "2021-12-16T11:35:45.000Z",
        updatedAt: "2021-12-16T11:35:45.000Z",
        feedbacks: [
          {
            id: 7,
            content: "Please reconsider",
            category: "HelpfulNag",
            valuation: "NEGATIVE",
            gradingId: 9,
            positionId: "c3970e95-8bf9-4476-9879-38d4a09109b3",
            positionX: 0,
            positionY: 0,
            createdAt: "2021-12-16T11:35:45.000Z",
            updatedAt: "2021-12-16T11:35:45.000Z",
          },
        ],
      },
      {
        id: 10,
        result: "0.07",
        resultType: "RELATIVE",
        logMessage:
          'Got DTO from KEAMOD backend: assessmentInfo {\n  assessmentId: 4\n  schematreeId: 7\n  gradingserviceId: 1\n  weight: 25\n  maxTotalscore: 10.0\n}\nsubmissionModel: "{\\"type\\":\\"EPC\\",\\"graph\\":{\\"cells\\":[{\\"z\\":5,\\"id\\":\\"f597aff9-ec00-4436-a368-cef003d50c7e\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"c56dcd83-bb4a-41fc-bedc-760155b6ea62\\"},\\"target\\":{\\"id\\":\\"6f54b0ae-c522-4d29-80d8-d0aaea396fac\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":5,\\"id\\":\\"a4f8c82b-55c6-4998-b7c8-9ba7d6c59200\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"6f54b0ae-c522-4d29-80d8-d0aaea396fac\\"},\\"target\\":{\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":5,\\"id\\":\\"041a3eee-2cbd-4995-8f06-53313672d220\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\"},\\"target\\":{\\"id\\":\\"293f7f94-058a-4b1f-94c7-f20bac010f79\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":5,\\"id\\":\\"6b875066-b328-45bf-97be-89ee10c03116\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\"},\\"target\\":{\\"id\\":\\"62ba1cb1-7d1a-429e-95be-2a345d9878b5\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":10,\\"id\\":\\"293f7f94-058a-4b1f-94c7-f20bac010f79\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKEvent\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"A\\"}},\\"label\\":\\"A\\",\\"position\\":{\\"x\\":470,\\"y\\":460},\\"fillColor\\":\\"#FFFFFF\\",\\"labelColor\\":\\"#333333\\",\\"strokeColor\\":\\"#333333\\",\\"strokeWidth\\":2},{\\"z\\":11,\\"id\\":\\"62ba1cb1-7d1a-429e-95be-2a345d9878b5\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKEvent\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"B\\"}},\\"label\\":\\"B\\",\\"position\\":{\\"x\\":1020,\\"y\\":430},\\"fillColor\\":\\"#FFFFFF\\",\\"labelColor\\":\\"#333333\\",\\"strokeColor\\":\\"#333333\\",\\"strokeWidth\\":2},{\\"z\\":13,\\"id\\":\\"c56dcd83-bb4a-41fc-bedc-760155b6ea62\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKEvent\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"Start-Ereignis\\"}},\\"label\\":\\"Start-Ereignis\\",\\"position\\":{\\"x\\":720,\\"y\\":80},\\"fillColor\\":\\"#FFFFFF\\",\\"labelColor\\":\\"#333333\\",\\"strokeColor\\":\\"#333333\\",\\"strokeWidth\\":2},{\\"z\\":14,\\"id\\":\\"6f54b0ae-c522-4d29-80d8-d0aaea396fac\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKFunction\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"Function 1\\"}},\\"label\\":\\"Function 1\\",\\"position\\":{\\"x\\":720,\\"y\\":240}},{\\"z\\":15,\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\",\\"size\\":{\\"width\\":50,\\"height\\":50},\\"type\\":\\"kea.EPKConnector\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"XOR\\",\\"fontSize\\":14}},\\"position\\":{\\"x\\":800,\\"y\\":370},\\"connectorType\\":\\"XOR\\"}],\\"timesCopied\\":0,\\"dragStartPosition\\":{}}}"\nmodelingLanguage: "EPC"\n\r\nStart grading...\r\nGrading was successful...',
        jobSuccessful: true,
        executionTimeMillis: 1337,
        assessmentId: 4,
        gradingserviceId: 1,
        schematreeId: 7,
        createdAt: "2021-12-16T11:35:45.000Z",
        updatedAt: "2021-12-16T11:35:45.000Z",
        feedbacks: [
          {
            id: 8,
            content: "Please reconsider",
            category: "HelpfulNag",
            valuation: "NEGATIVE",
            gradingId: 10,
            positionId: "",
            positionX: 0,
            positionY: 0,
            createdAt: "2021-12-16T11:35:45.000Z",
            updatedAt: "2021-12-16T11:35:45.000Z",
          },
        ],
      },
      {
        id: 11,
        result: "0.60",
        resultType: "RELATIVE",
        logMessage:
          'Got DTO from KEAMOD backend: assessmentInfo {\n  assessmentId: 4\n  schematreeId: 8\n  gradingserviceId: 1\n  weight: 25\n  maxTotalscore: 10.0\n}\nsubmissionModel: "{\\"type\\":\\"EPC\\",\\"graph\\":{\\"cells\\":[{\\"z\\":5,\\"id\\":\\"f597aff9-ec00-4436-a368-cef003d50c7e\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"c56dcd83-bb4a-41fc-bedc-760155b6ea62\\"},\\"target\\":{\\"id\\":\\"6f54b0ae-c522-4d29-80d8-d0aaea396fac\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":5,\\"id\\":\\"a4f8c82b-55c6-4998-b7c8-9ba7d6c59200\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"6f54b0ae-c522-4d29-80d8-d0aaea396fac\\"},\\"target\\":{\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":5,\\"id\\":\\"041a3eee-2cbd-4995-8f06-53313672d220\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\"},\\"target\\":{\\"id\\":\\"293f7f94-058a-4b1f-94c7-f20bac010f79\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":5,\\"id\\":\\"6b875066-b328-45bf-97be-89ee10c03116\\",\\"type\\":\\"kea.Link\\",\\"attrs\\":{\\"line\\":{\\"targetMarker\\":{\\"d\\":\\"M 20 -10 L 0 0 L 20 10\\",\\"fill\\":\\"none\\",\\"stroke\\":\\"black\\",\\"stroke-width\\":2,\\"stroke-dasharray\\":\\"100%\\"}}},\\"source\\":{\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\"},\\"target\\":{\\"id\\":\\"62ba1cb1-7d1a-429e-95be-2a345d9878b5\\"},\\"linkType\\":\\"solid\\",\\"keaLabels\\":[],\\"sourceMarker\\":\\"none\\",\\"targetMarker\\":\\"arrow\\"},{\\"z\\":10,\\"id\\":\\"293f7f94-058a-4b1f-94c7-f20bac010f79\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKEvent\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"A\\"}},\\"label\\":\\"A\\",\\"position\\":{\\"x\\":470,\\"y\\":460},\\"fillColor\\":\\"#FFFFFF\\",\\"labelColor\\":\\"#333333\\",\\"strokeColor\\":\\"#333333\\",\\"strokeWidth\\":2},{\\"z\\":11,\\"id\\":\\"62ba1cb1-7d1a-429e-95be-2a345d9878b5\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKEvent\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"B\\"}},\\"label\\":\\"B\\",\\"position\\":{\\"x\\":1020,\\"y\\":430},\\"fillColor\\":\\"#FFFFFF\\",\\"labelColor\\":\\"#333333\\",\\"strokeColor\\":\\"#333333\\",\\"strokeWidth\\":2},{\\"z\\":13,\\"id\\":\\"c56dcd83-bb4a-41fc-bedc-760155b6ea62\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKEvent\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"Start-Ereignis\\"}},\\"label\\":\\"Start-Ereignis\\",\\"position\\":{\\"x\\":720,\\"y\\":80},\\"fillColor\\":\\"#FFFFFF\\",\\"labelColor\\":\\"#333333\\",\\"strokeColor\\":\\"#333333\\",\\"strokeWidth\\":2},{\\"z\\":14,\\"id\\":\\"6f54b0ae-c522-4d29-80d8-d0aaea396fac\\",\\"size\\":{\\"width\\":200,\\"height\\":100},\\"type\\":\\"kea.EPKFunction\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"Function 1\\"}},\\"label\\":\\"Function 1\\",\\"position\\":{\\"x\\":720,\\"y\\":240}},{\\"z\\":15,\\"id\\":\\"b286fcf3-be85-4e5e-9adb-f0fcbf867267\\",\\"size\\":{\\"width\\":50,\\"height\\":50},\\"type\\":\\"kea.EPKConnector\\",\\"angle\\":0,\\"attrs\\":{\\"label\\":{\\"text\\":\\"XOR\\",\\"fontSize\\":14}},\\"position\\":{\\"x\\":800,\\"y\\":370},\\"connectorType\\":\\"XOR\\"}],\\"timesCopied\\":0,\\"dragStartPosition\\":{}}}"\nmodelingLanguage: "EPC"\n\r\nStart grading...\r\nGrading was successful...',
        jobSuccessful: true,
        executionTimeMillis: 1337,
        assessmentId: 4,
        gradingserviceId: 1,
        schematreeId: 8,
        createdAt: "2021-12-16T11:35:46.000Z",
        updatedAt: "2021-12-16T11:35:46.000Z",
        feedbacks: [
          {
            id: 9,
            content: "Please reconsider",
            category: "HelpfulNag",
            valuation: "NEGATIVE",
            gradingId: 11,
            positionId: "",
            positionX: 11,
            positionY: 23,
            createdAt: "2021-12-16T11:35:46.000Z",
            updatedAt: "2021-12-16T11:35:46.000Z",
          },
        ],
      },
    ],
  },
};

export const apiresponsesample: APIResponseSubmissionExerciseAssessment = {
  success: true,
  statusCode: 200,
  statusMsg: "OK",
  timestamp: "2021-12-02T09:37:48.795Z",
  data: {
    id: 7,
    totalscore: 1.32,
    maxTotalScore: "10.00",
    comment: null,
    autoAssessment: false,
    finalResult: false,
    status: "initialized",
    submissionExerciseId: 3,
    schemaId: 1,
    createdAt: "2021-11-21T17:20:46.000Z",
    updatedAt: "2021-11-23T21:42:47.000Z",
    feedbacksmanual: [],
    gradings: [
      {
        id: 26,
        result: "0.66",
        resultType: "RELATIVE",
        logMessage: "0.66 = b partite: false, directed: true, placetransition: true, ",
        jobSuccessful: true,
        executionTimeMillis: 59,
        assessmentId: 7,
        gradingserviceId: 1,
        schematreeId: 4,
        createdAt: "2021-11-23T11:06:25.000Z",
        updatedAt: "2021-11-23T11:06:25.000Z",
        feedbacks: [
          {
            id: 3,
            content: "Der Graph hat nur Stellen und Transistionen. Sehr gut.",
            category: "Syntax",
            positionId: "c3970e95-8bf9-4476-9879-38d4a09109b3",
            positionX: 0,
            positionY: 0,
            valuation: "POSITIVE",
            gradingId: 26,
            createdAt: "2021-11-23T11:06:25.000Z",
            updatedAt: "2021-11-23T11:06:25.000Z",
          },
          {
            id: 2,
            content: "Der Graph ist ein gerichteter Graph.",
            category: "Syntax",
            positionId: "",
            positionX: 0,
            positionY: 0,
            valuation: "POSITIVE",
            gradingId: 26,
            createdAt: "2021-11-23T11:06:25.000Z",
            updatedAt: "2021-11-23T11:06:25.000Z",
          },
          {
            id: 1,
            content: "Der Graph ist nicht bipartite.",
            category: "Syntax",
            positionId: "",
            positionX: 0,
            positionY: 0,
            valuation: "NEGATIVE",
            gradingId: 26,
            createdAt: "2021-11-23T11:06:25.000Z",
            updatedAt: "2021-11-23T11:06:25.000Z",
          },
        ],
      },
      {
        id: 27,
        result: "0.66",
        resultType: "RELATIVE",
        logMessage: "0.66 = b partite: false, directed: true, placetransition: true, ",
        jobSuccessful: true,
        executionTimeMillis: 115,
        assessmentId: 7,
        gradingserviceId: 1,
        schematreeId: 4,
        createdAt: "2021-11-23T21:42:44.000Z",
        updatedAt: "2021-11-23T21:42:44.000Z",
        feedbacks: [
          {
            id: 6,
            content: "Der Graph hat nur Stellen und Transistionen. Sehr gut.",
            category: "Syntax",
            positionId: "",
            positionX: 0,
            positionY: 0,
            valuation: "POSITIVE",
            gradingId: 27,
            createdAt: "2021-11-23T21:42:45.000Z",
            updatedAt: "2021-11-23T21:42:45.000Z",
          },
          {
            id: 5,
            content: "Der Graph ist ein gerichteter Graph.",
            category: "Syntax",
            positionId: "",
            positionX: 600,
            positionY: 400,
            valuation: "POSITIVE",
            gradingId: 27,
            createdAt: "2021-11-23T21:42:45.000Z",
            updatedAt: "2021-11-23T21:42:45.000Z",
          },
          {
            id: 4,
            content: "Der Graph ist nicht bipartite.",
            category: "Syntax",
            positionId: "",
            positionX: 0,
            positionY: 0,
            valuation: "NEGATIVE",
            gradingId: 27,
            createdAt: "2021-11-23T21:42:45.000Z",
            updatedAt: "2021-11-23T21:42:45.000Z",
          },
        ],
      },
    ],
  },
};
